import React, { lazy, Suspense } from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-dom';
import './index.css';
import './fonts/Elkwood.ttf';
import './fonts/Nunito-Regular.ttf';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Planets } from 'react-preloaders';
import'bootstrap/dist/js/bootstrap';

// import App from './App';
// import { BrowserRouter as Router } from 'react-router-dom';
import { HashRouter as Router } from 'react-router-dom'
// import * as serviceWorker from './serviceWorker';

const App = lazy(() => import('./App'));


const rootElement = document.getElementById('root');

render(
	<Suspense
		fallback={
			<div>
				<Planets
					background='linear-gradient(180deg, #003953 0%, #006699 100%)'
					color={'#ffffff'}
				/>
			</div>
		}
	>
		<React.StrictMode>
			{/* basename == index.php header location in root*/}
			<Router>
				<App />
			</Router>
		</React.StrictMode>
	</Suspense>,
	rootElement
)
